import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import { useForm } from "react-hook-form";
import Content from "../../layout/content/Content";
import { Block, Col, DataTable, PreviewAltCard, Row } from "../../components/Component";
import { Form, Offcanvas, OffcanvasBody, OffcanvasHeader } from "reactstrap";

import { createBrandAPI, createDiseaseAPI, listBrandAPI, listDiseaseAPI, updateBrandAPI, updateDiseaseAPI } from "../../api/master/indes";

import { toast } from "react-toastify";

import { BASE_URL_IMG } from "../../assets/constants";
import MyButton from "../../MyComp/UI/form/MyButton";
import ViewImage from "../../MyComp/UI/modals/ViewImage";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import MyInput from "../../MyComp/UI/form/MyInput";
import Status from "../../MyComp/UI/form/Status";
import useLogout from "../../hooks/useLogout";
import ImageUpload from "../../MyComp/UI/form/ImageUpload";
import MyTextArea from "../../MyComp/UI/form/MyTextArea";
import Table from "../../MyComp/UI/DataTable/Table";
import CKEditor from "../../MyComp/UI/CK Editor/index";
import MySelect from "../../MyComp/UI/form/MySelect";
import { productDDAPI } from "../../api/dropdown";
const Disease = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      data: [],
      meta_image: null,
      meta_img: null,
      product_banner_img: null,
      product_banner_image: null,
      product_images: [],
      productTypeDD: [],
      brandsDD: [],
      categoryDD: [],
      unitDD: [],
      ingredientDD: [],
      diseaseDD: [],
      isPub: false,
    },
  });
  const logout = useLogout();

  const [isOpen, setIsOpen] = useState(false);
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState("Add");
  const isLoading = watch("isLoading");
  const [data, setData] = useState([]);

  const toggleCanvas = () => {
    setIsOpen((prev) => !prev);
    if (isOpen) fReset();
  };

  const selectorCheck = (e) => {
    const updated = data.map((item) => ({ ...item, checked: e.target.checked }));
    setData(updated);
  };
  const handleTogglePublish = (row) => {
    setValue("isPub", true);
    setValue("selectedRow", row);
    setShowModal(true);
  };

  const selectorDeleteUser = () => setData(data.filter((d) => !d.checked));
  const handleImageOpenPreview = (row) => {
    setImageOpen(!imageOpen);
    setValue("image_preview", row);
    trigger("image_preview");
  };
  useEffect(() => {
    getDiseaseList();
  }, []);
  const getDiseaseList = () => {
    listDiseaseAPI()
      .then((res) => {
        if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else if (res.data.status === true) {
          setData(res.data.data);
          setValue("isLoading", false);
        } else {
          setData([]);
          setValue("isLoading", false);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };

  const onFormSubmit = (data) => {
    console.log(data, "data");

    const formData = new FormData();
    formData.append("status", watch("status")?.value);
    const i = watch("disease_img");
    if (data?.disease_img) {
      formData.append("img", i);
    }

    const bannerImg = watch("banner_img");
    if (data?.banner_image) {
      formData.append("banner_image", bannerImg);
    }

    formData.append("name", watch("disease"));
    formData.append("description", watch("description"));
    const extra_diseases_details = window?.CKEDITOR?.instances.extra_diseases_details?.getData();
    const cleanedContent = extra_diseases_details.replace(/&nbsp;/g, " ");
    formData.append("extra_diseases_details", cleanedContent);
    formData.append(
      "similar_products",
      watch("related_products")?.map((item) => item.value)
    );
    if (mode == "Edit") {
      formData.append("id", watch("selectedRow")?.id);
    }

    if (mode == "Add") {
      createDiseaseAPI(formData)
        .then((res) => {
          //const status = decrypt(res.data.status);
          if (res.data.status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getDiseaseList();
            setIsOpen(false);
            setValue("isLoading", false);
          } else if (res.data.status === false) {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err?.response?.data?.message);
        });
    }
    if (mode == "Edit") {
      updateDiseaseAPI(formData)
        .then((res) => {
          //const status = decrypt(res.data.status);
          if (res.data.status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getDiseaseList();
            setIsOpen(false);
            setValue("isLoading", false);
          } else if (res.data.status === false) {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err?.response?.data?.message);
        });
    }
  };
  const handleEdit = (row) => {
    window.scrollTo(0, 0);
    setValue("selectedRow", row);
    setIsOpen(true);
    setMode("Edit");
    setValue("disease", row?.name);
    setValue("description", row?.description);
    setValue("status", {
      label: row.status ? "Active" : "InActive",
      value: row.status,
    });
    const imageUrl = `${BASE_URL_IMG}${row.image}`;
    const imageUrlBnner = `${BASE_URL_IMG}${row?.banner_image}`;
    setValue("disease_image", imageUrl); //image_url value
    setValue("banner_image", imageUrlBnner); //image_url value
      setValue("related_products", row?.similar_products);
    setTimeout(() => {
      if (window?.CKEDITOR?.instances?.extra_diseases_details) {
        window.CKEDITOR.instances.extra_diseases_details.setData(row?.extra_diseases_details || ""); // Set existing content
      }
    }, 500);

  };
  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };
  const confirmStatusChange = (data) => {
    const formData = new FormData();
    const updatedStatus = watch("selectedRow").status === true ? false : true;
    formData.append("status", updatedStatus);
    formData.append("id", watch("selectedRow")?.id);
    setValue("isLoading", true);

    updateDiseaseAPI(formData)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          getDiseaseList();
          setIsOpen(false);
          setValue("isLoading", false);
          setShowModal(false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const fReset = () => {
    setMode("Add");
    setValue("disease", "");
    setValue("description", "");
    setValue("status", "");
    setValue("disease_image", null);
    setValue("banner_image", null);
    setValue("related_products", null);
  };
  const handleImageClose = () => {
    setImageOpen(!imageOpen);
  };

  const onSelectChange = (e, id) => {
    const updated = data.map((item) => (item.id === id ? { ...item, checked: e.target.checked } : item));
    setData(updated);
  };
  const selectorSuspendUser = () => setData(data.map((d) => (d.checked ? { ...d, status: false } : d)));
  useEffect(() => {
    getProductDD();
  }, [mode]);

  const getProductDD = () => {
    productDDAPI()
      .then((res) => {
        if (res.data.status === true) {
          toast.clearWaitingQueue();
          if (mode == "Edit") {
            const filtered = res.data.data.filter(
              (item) => item?.value !== watch("selectedRow")?.id
            );
            setValue("productDD", filtered);
          } else {
            setValue("productDD", res.data.data);
          }

          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("productDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };

  return (
    <>
      <Head title={"Product | Master"} />
      <Content>
        {/* <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Manage Products"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    resetF();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead> */}
        <Block>
          <>
            {" "}
            <div className="container my-5 text-center">
              {/* Button to open offcanvas */}

              <Offcanvas isOpen={isOpen} direction="end">
                <OffcanvasHeader toggle={toggleCanvas}>Disease </OffcanvasHeader>
                <OffcanvasBody>
                  <PreviewAltCard>
                    <Form onSubmit={handleSubmit(onFormSubmit)}>
                      <Row>
                        <Col md="12" className={``}>
                          <MyInput
                            register={register}
                            watch={watch}
                            setValue={setValue}
                            trigger={trigger}
                            errors={errors}
                            title={"Disease"}
                            name={"disease"}
                            placeholder={"Enter disease name"}
                            required
                            min={2}
                            max={50}
                          />
                        </Col>
                        <Col md={12}>
                          <ImageUpload
                            id="disease_image"
                            watch={watch}
                            label={"Upload Disease Image"}
                            errors={errors}
                            register={register}
                            clearErrors={clearErrors}
                            trigger={trigger}
                            image={"disease_img"}
                            image_url={"disease_image"}
                            setValue={setValue}
                            handleImageOpenPreview={handleImageOpenPreview}
                            required
                            getValues={getValues}
                          />
                        </Col>
                        <Col md="12">
                          <ImageUpload
                            id="banner_image"
                            watch={watch}
                            label={"Upload Banner Image"}
                            errors={errors}
                            register={register}
                            trigger={trigger}
                            clearErrors={clearErrors}
                            image={"banner_img"}
                            image_url={"banner_image"}
                            setValue={setValue}
                            handleImageOpenPreview={handleImageOpenPreview}
                            required
                            getValues={getValues}
                          />
                        </Col>
                        <Col md={12}>
                          <CKEditor title={"Extra Disease Details"} id="extra_diseases_details" />
                        </Col>
                        <Col md={12}>
                          <MySelect
                            register={register}
                            watch={watch}
                            setValue={setValue}
                            trigger={trigger}
                            errors={errors}
                            title={"Related Products"}
                            name={"related_products"}
                            placeholder={"Select Related Products"}
                            required
                            options={watch("productDD")}
                            multi
                          />
                        </Col>
                        <Col md={`12`}>
                          <Status
                            register={register}
                            watch={watch}
                            setValue={setValue}
                            trigger={trigger}
                            errors={errors}
                          />
                        </Col>
                      </Row>
                      <Col md="12" className={``}>
                        <MyTextArea
                          register={register}
                          watch={watch}
                          setValue={setValue}
                          trigger={trigger}
                          errors={errors}
                          title={"Description"}
                          name={"description"}
                          placeholder={"Enter short disease description"}
                          required
                          min={25}
                          max={300}
                          cols={2}
                          row={2}
                        />
                      </Col>
                      <Col md="12" className={``}>
                        <div className="form-group" style={{ marginTop: "31px" }}>
                          <MyButton isLoading={isLoading} mode={mode} />
                        </div>
                      </Col>
                    </Form>
                  </PreviewAltCard>
                </OffcanvasBody>
              </Offcanvas>

              {/* Offcanvas (Right Side) */}
            </div>
          </>

          <Table
            title="Disease List"
            data={data}
            publicButton={false}
            columns={[

              { key: "image", label: "Name", type: "image" },


              { key: "description", label: "Description" },
              //  { key: "order", label: "Order" },

              // { key: "createdBy", label: "Created By" },

            ]}
            searchKeys={["name", "description"]}
            nameColumn={"name"}
            imageBaseURL={BASE_URL_IMG}
            onEditClick={handleEdit}
            selectorCheck={selectorCheck}
            selectorDeleteUser={selectorDeleteUser}
            selectorSuspendUser={selectorSuspendUser}
            onSelectChange={onSelectChange}
            statusFilterEnabled={true}
            isOpen={isOpen}
            confirmStatusChange={confirmStatusChange}
            setIsOpen={setIsOpen}
            resetF={fReset}
            handleImageOpenPreview={handleImageOpenPreview}
            handleToggleStatus={handleToggleStatus}
            toggleCanvas={toggleCanvas}
            handleTogglePublish={handleTogglePublish}
          />

          {/* <MyDataTable data={data || []} columns={column} title={"Product List"} isLoading={isLoading} /> */}
        </Block>
      </Content>
      <ViewImage url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
      <ConfirmModal
        isOpen={showModal}
        toggle={() => {
          setShowModal(!showModal);
          setValue("isPub", false);
        }}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
        isPub={watch("isPub")}
        data={watch("selectedRow")}
      />
    </>
  );
};

export default Disease;
